/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { DynamicFormFromJSON, DynamicFormListItemFromJSON, FormSubmitToJSON, } from '../models/index';
/**
 *
 */
export class FormsApi extends runtime.BaseAPI {
    /**
     */
    apiFormsSubmitPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['formSubmit'] == null) {
                throw new runtime.RequiredError('formSubmit', 'Required parameter "formSubmit" was null or undefined when calling apiFormsSubmitPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/api/Forms/submit`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FormSubmitToJSON(requestParameters['formSubmit']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiFormsSubmitPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiFormsSubmitPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    apiFormsUpdatedPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['formSubmit'] == null) {
                throw new runtime.RequiredError('formSubmit', 'Required parameter "formSubmit" was null or undefined when calling apiFormsUpdatedPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            let urlPath = `/api/Forms/updated`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FormSubmitToJSON(requestParameters['formSubmit']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    apiFormsUpdatedPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiFormsUpdatedPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    getFormRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['documentId'] == null) {
                throw new runtime.RequiredError('documentId', 'Required parameter "documentId" was null or undefined when calling getForm().');
            }
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/api/Forms/{documentId}`;
            urlPath = urlPath.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId'])));
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DynamicFormFromJSON(jsonValue));
        });
    }
    /**
     */
    getForm(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFormRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getFormsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/api/Forms`;
            const response = yield this.request({
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DynamicFormListItemFromJSON));
        });
    }
    /**
     */
    getForms(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFormsRaw(initOverrides);
            return yield response.value();
        });
    }
}
